const QUANTITY_EPSILON = 0.0001;

export interface MaterialOperationQuantity {
  quantity: number;
  remaining: number;
}

export function resolveMaterialOperationQuantity(
  rawQuantity: string,
  availableQuantity: number,
  uom: string,
): MaterialOperationQuantity {
  if (!Number.isFinite(availableQuantity) || availableQuantity <= QUANTITY_EPSILON) {
    throw new Error('Il lotto non ha quantità disponibile');
  }

  const quantity = Number(rawQuantity.trim().replace(',', '.'));
  if (!Number.isFinite(quantity) || quantity <= 0) {
    throw new Error('Quantità non valida');
  }
  if (quantity > availableQuantity + QUANTITY_EPSILON) {
    throw new Error(`Disponibili solo ${availableQuantity} ${uom}`);
  }

  const normalizedQuantity = Math.min(quantity, availableQuantity);
  return {
    quantity: normalizedQuantity,
    remaining: Math.max(
      0,
      Number((availableQuantity - normalizedQuantity).toFixed(12)),
    ),
  };
}
